import type { Disposable, Model } from '@patsnap/tahiti-core';
import type { OarTaskContent } from '../types/oar-types';

export interface OarTaskContentModel extends Model<OarTaskContent>, Disposable {}

export const OarTaskContentModel = Symbol.for('OarTaskContentModel');
